module.exports = "/images/amex.jpg?4936afb585920f60656d7d2877988cc7";


//////////////////
// WEBPACK FOOTER
// ./public/img/amex.jpg
// module id = jtV2
// module chunks = 5